import * as Types from '@haaretz/s-fragments/Types';


/**
 * -----------------------------------------------------------------------------
 * ⚠️  AUTO-GENERATED FILE - DO NOT EDIT MANUALLY ⚠️
 * -----------------------------------------------------------------------------
 * This file was automatically generated by GraphQL Codegen.
 * Any manual changes will be overwritten.
 * -----------------------------------------------------------------------------
 */

export type PurchaseToggleKickerFragment = (
  { billing: Types.BillingType, text?: string | null }
  & { __typename: 'PurchaseToggleKicker' }
);


export type PurchaseToggleKickerFragmentVariables = Types.Exact<{ [key: string]: never; }>;

export const PurchaseToggleKickerFragmentGql = `
    fragment PurchaseToggleKickerFragment on PurchaseToggleKicker {
  __typename
  billing
  text
}
    `;